// Shopping wrapper styles
export default ({ theme, isRightDrawerOpen }) => `
    background-color: ${theme.neutralColor};
    color: ${theme.neutralTextColor};
    position: relative;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    padding-right: ${isRightDrawerOpen ? '600px' : '0'};

    .shopping-container{
      display: flex;
      flex-direction: column;
      width: 100%;
      min-width: 0;
      flex: 1 1 auto;
    }
    
    .shopping-notification{
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .shopping-header-strip {
      width: 100%;
      display: flex;
      flex-direction: column;
    }
    
    .main-shopping-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      min-width: 0;
      flex: 1 1 auto;
    }

    .categories {
      width: 200px;
      display: flex;
      height: calc(100vh - 64px);
      position: sticky;
      top: 0;
      background-color: #fff;
    }

    .search-stores-listing {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 1286px;
      min-width: 0;
      flex: 1 1 auto;

      .search-tabs-pagination-container {
        width: 100%;
        background-color: ${theme.neutralColor};
        position: sticky;
        top: 0px;
        z-index: 1;
        border-bottom: solid 1px ${theme.borderColor};
        margin-top: 20px;
      }
    }

    @media(max-width: 1023px) {
      .categories {
        display: none;
      }

      .search-stores-listing {
        width: 100%;
        margin-left: 0px;

        .search-tabs-pagination-container {
          margin-top: 5px;
        }
      }
    }

    @media(max-width: 767px) {
      padding-right: 0;
    }
  `;
